var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToTopArrow = function SvgToTopArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.638 4.16a.49.49 0 0 1 .723 0l4.253 4.253c.213.213.213.553 0 .723l-.85.85c-.17.214-.51.214-.723 0l-2-2.168v7.672c0 .297-.255.51-.51.51H7.51A.491.491 0 0 1 7 15.49V7.818L4.958 9.987c-.213.213-.553.213-.723 0l-.85-.85c-.214-.171-.214-.511 0-.724L7.637 4.16zM.467 2.04A.467.467 0 0 1 0 1.573V.467C0 .209.209 0 .467 0h15.066c.258 0 .467.209.467.467v1.106a.467.467 0 0 1-.467.467H.467z",
    fill: "#004152"
  })));
};

export default SvgToTopArrow;